import React, {Component, Fragment} from 'react';
import {Routes, Route} from "react-router-dom"
import {urlDynamic} from "../../settings/utils/urlDynamic";
import Home from "../components/home/main/Home";
import NewsAll from "../components/news/main/NewsAll";
import GozareshTasviri from "../components/gozareshTasviri/main/GozareshTasviri";
import Pages from "../components/pages/main/Pages";
import NewsAllMarjaiat from "../components/newsMarjaiat/main/NewsAllMarjaiat";
import NotFound from "../components/notFound/main/NotFound";
import GozareshTasviriAll from "../components/gozareshTasviri/main/GozareshTasviriAll";
import Error500 from "../components/error500/main/Error500";
import Search from "../components/search/main/Search";
import KotobMarjaiatElmi from "../components/kotob/main/KotobMarjaiatElmi";
import MahsoolatJadid from "../components/kotob/main/MahsoolatJadid";
import HekmatBonyan from "../components/kotob/main/HekmatBonyan";
import KarAfarin from "../components/kotob/main/KarAfarin";
import PezeshkKhanevade from "../components/kotob/main/PezeshkKhanevade";
import HeyatElmi from "../components/kotob/main/HeyatElmi";
import EghtesadModiriat from "../components/kotob/main/EghtesadModiriat";
import Salamat from "../components/kotob/main/Salamat";
import Bimarestan from "../components/kotob/main/Bimarestan";
import RotbeBandi from "../components/kotob/main/RotbeBandi";
import Nokhbegan from "../components/kotob/main/Nokhbegan";
import Corona from "../components/kotob/main/Corona";
import NiroyeEnsani from "../components/niroyeEnsani/main/NiroyeEnsani";
import AmoozeshSalamat from "../components/kotob/main/amoozeshSalamat";
import MahsoolatSiasati from "../components/kotob/main/MahsoolatSiasati";
import Noavar from "../components/kotob/main/Noavar";
import SazVaKar from "../components/kotob/main/SazVaKar";
import SarFasl from "../components/kotob/main/SarFasl";
import Login from "../components/login/main/Login";
import Profile from "../components/profile/main/Profile";
import Signup from "../components/signup/main/Signup";
import ForgotPassword from "../components/forgetPassword/main/ForgotPassword";

class App extends Component {
    render() {
        return (
            <Fragment>
                <Routes>
                    <Route path={urlDynamic.path.homeFa} element={<Home/>}/>
                    <Route path={urlDynamic.path.error500} element={<Error500/>}/>
                    <Route path={urlDynamic.path.search} element={<Search/>}/>
                    <Route path={urlDynamic.path.newsAllFa} element={<NewsAll/>}/>
                    <Route path={urlDynamic.path.kotobMarjaitElmiFa} element={<KotobMarjaiatElmi/>}/>
                    <Route path={urlDynamic.path.mahsoolatJadid} element={<MahsoolatJadid/>}/>
                    <Route path={urlDynamic.path.hekmatBonyan} element={<HekmatBonyan/>}/>
                    <Route path={urlDynamic.path.karAfarin} element={<KarAfarin/>}/>
                    <Route path={urlDynamic.path.pezeshkKhanevade} element={<PezeshkKhanevade/>}/>
                    <Route path={urlDynamic.path.heyatElmi} element={<HeyatElmi/>}/>
                    <Route path={urlDynamic.path.eghtesadModiriat} element={<EghtesadModiriat/>}/>
                    <Route path={urlDynamic.path.salamat} element={<Salamat/>}/>
                    <Route path={urlDynamic.path.bimarestan} element={<Bimarestan/>}/>
                    <Route path={urlDynamic.path.rotbeBandi} element={<RotbeBandi/>}/>
                    <Route path={urlDynamic.path.niroyeEnsani} element={<NiroyeEnsani/>}/>
                    <Route path={urlDynamic.path.nokhbegan} element={<Nokhbegan/>}/>
                    <Route path={urlDynamic.path.corona} element={<Corona/>}/>
                    <Route path={urlDynamic.path.sazVaKar} element={<SazVaKar/>}/>
                    <Route path={urlDynamic.path.sarFasl} element={<SarFasl/>}/>
                    <Route path={urlDynamic.path.login} element={<Login/>}/>
                    <Route path={urlDynamic.path.profile} element={<Profile/>}/>
                    <Route path={urlDynamic.path.signup} element={<Signup/>}/>
                    <Route path={urlDynamic.path.forgetPassword} element={<ForgotPassword/>}/>
                    <Route path={urlDynamic.path.noavar} element={<Noavar/>}/>
                    <Route path={urlDynamic.path.mahsoolatSiasati} element={<MahsoolatSiasati/>}/>
                    <Route path={urlDynamic.path.amoozeshSalamat} element={<AmoozeshSalamat/>}/>
                    <Route path={urlDynamic.path.newsAllMarjaiatFa} element={<NewsAllMarjaiat/>}/>
                    <Route path={':slug1' + urlDynamic.path.gozareshTasviriFa} element={<GozareshTasviri/>}/>
                    <Route path={urlDynamic.path.gozareshTasviriFa} element={<GozareshTasviriAll/>}/>
                    <Route path={urlDynamic.path.homeFa + ':slug1'} element={<Pages/>}/>
                    <Route path={'*'} element={<NotFound/>}/>
                </Routes>
            </Fragment>
        )
    }
}

export default App